import React from "react";
import InternalLayout from "../../../../../../layouts/internalLayout";
import Left from "./left";

const GlazingDesigns = () => {
  return (
    <>
      <InternalLayout
        pageTitle="Colours"
        layoutType="full"
        leftContent={<Left />}
        rightContent={""}
      />
    </>
  );
};

export default GlazingDesigns;
